import React from 'react';
import { Link } from 'react-router-dom'; // Import the Link component
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'font-awesome/css/font-awesome.min.css';
import '../assets/css/style.css';
function Header() {
    return (
        <header className="mainMenu">
            <nav className="navbar navbar-default">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button
                            type="button"
                            className="navbar-toggle collapsed"
                            data-toggle="collapse"
                            data-target="#bs-example-navbar-collapse-1"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        {/* Use Link component instead of <a> */}
                        <Link className="navbar-brand" to="/">
                            <img
                                src="logo.jpg"
                                alt="Adber Infra India Pvt. Ltd."
                                title="Adber Infra India Pvt. Ltd."
                            />
                        </Link>
                    </div>
                    <div
                        className="collapse navbar-collapse"
                        id="bs-example-navbar-collapse-1"
                    >
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                {/* Use Link component instead of <a> */}
                                <Link to="/">
                                    <i className="fa fa-home"></i> Home{' '}
                                </Link>
                            </li>
                            <li className="dropdown">
                                <Link
                                    to="#"
                                    className="dropdown-toggle"
                                    data-toggle="dropdown"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="fa fa-users"></i> About Us{' '}
                                    <span className="caret"></span>
                                </Link>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about-us"> About Adber Infra </Link>
                                    </li>
                                    <li>
                                        <Link to="/why-choose-us"> Why Choose Us ? </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/services">
                                    <i className="fa fa-cogs"></i> Services{' '}
                                </Link>
                            </li>
                            <li>
                                <Link to="/clients">
                                    <i className="fa fa-users"></i> Clients{' '}
                                </Link>
                            </li>
                            <li>
                                <Link to="/career">
                                    <i className="fa fa-briefcase"></i> Career{' '}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us">
                                    <i className="fa fa-address-book"></i> Contact Us{' '}
                                </Link>
                            </li>
                            <li>
                                <a href="#">
                                    {' '}
                                    <button type="button" className="btn callBtn">
                                        <i className="fa fa-phone"></i> +91 7030332900{' '}
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;
